<template>
  <div v-if="!isFooterTabHidden" :class="{ iphoneXSeries: isIphoneXSeries }" class="footerTab">
    <div class="footerTab-inner">
      <div
        :class="{ active: !pageDetector.isParticipantsPage && !pageDetector.isMarriagesPage && !pageDetector.isClEventsPage }"
        class="footerTab-inner-tab tab-select"
        @click="sendOpixClickedDatas('to_mj')"
      >
        <custom-nuxt-link :to="previousPathToTopOrSearchMj">
          <p><icon :size="2.08" fas="fa-glass-cheers" class="marginR2" /></p>
          <p class="text">イベントを探す</p>
        </custom-nuxt-link>
      </div>
      <div
        :class="{
          active: pageDetector.isParticipantsPage && !['dating_event_request', 'dating_events'].includes($route.query.from),
          badge: needShowClBadge
        }"
        class="footerTab-inner-tab tab-select"
        @click="onClClicked"
      >
        <custom-nuxt-link to="/participants/profile/?step=gender">
          <p><icon :size="2.08" fas="fa-users" class="marginR2" /></p>
          <p class="text">参加者を見る</p>
        </custom-nuxt-link>
      </div>
      <div
        :class="{
          active:
            pageDetector.isClEventsPage || (pageDetector.isParticipantsPage && ['dating_event_request', 'dating_events'].includes($route.query.from)),
          badge: !isVisitedClEventsPage
        }"
        class="footerTab-inner-tab tab-select"
      >
        <custom-nuxt-link to="/cl_events/dating_events">
          <p><icon :size="2.08" fas="fa-hand-holding-heart" class="marginR2" /></p>
          <p class="text">すぐに出会う</p>
        </custom-nuxt-link>
      </div>
    </div>
  </div>
</template>

<script>
import Cookies from 'mj-cookie'
import GTM from '@/utils/tracking/gtm'
import PageDetector from '@/utils/PageDetector'
import TrackingUserMixin from '@/utils/mixins/TrackingUserMixin'
import { CACHE_FOOTER_TAB } from '@/utils/constants/serverCaching'
import { VISITED_CL_EVENT_PAGE_COOKIE_KEY } from '@/utils/constants/commons'
import BrowserStorage from '@/utils/BrowserStorage'
import useABTestV2 from '@/utils/abtest/useABTestV2'
import { FOOTER_TAB_AB_TEST_CONFIG } from '@/utils/abtest/abTestConfig'
import { AB_TEST_FOOTER_TAB_GROUP_ALLOCATION } from '@/utils/constants/gaCustomEventSet'

const LAST_SHOW_CL_VIA_BADGED_TAB_KEY = 'last_show_cl_via_badged_tab_at'
const FOOTER_TAB_AB_TEST_GA_SENT_KEY = 'footer_tab_ab_test_ga_sent_from_05_28'

export default {
  name: CACHE_FOOTER_TAB.name,
  serverCacheKey() {
    return Math.floor(Date.now() / CACHE_FOOTER_TAB.time)
  },
  mixins: [TrackingUserMixin],
  data() {
    return {
      forceHideClBadge: false,
      needShowClBadge: false,
      isVisitedClEventsPage: false,
      isFooterTabHidden: false
    }
  },
  computed: {
    pageDetector() {
      return new PageDetector(this.$route)
    },
    previousPathToTopOrSearchMj() {
      return this.$store.$state.previous_path_to_top_search_mj_page || '/'
    },
    localStorage() {
      return new BrowserStorage('localStorage')
    },
    isIphoneXSeries() {
      return this.$store.$state.iphone_x_series
    }
  },
  watch: {
    $route(to) {
      if (new PageDetector(to).isClEventsPage) this.visitClEventsPage()
    }
  },
  created() {
    this.setupFooterTabABTest()
  },
  mounted() {
    if (import.meta.client) {
      this.updateNeedShowClBadge()
      this.isVisitedClEventsPage = Cookies.get(VISITED_CL_EVENT_PAGE_COOKIE_KEY)
    }
  },
  methods: {
    sendOpixClickedDatas(clickTab) {
      this.sendMJCLFooterDatas('click', clickTab)
    },
    onClClicked() {
      this.sendOpixClickedDatas('to_cl')
      if (this.needShowClBadge) {
        this.localStorage.setItem(LAST_SHOW_CL_VIA_BADGED_TAB_KEY, Date.now())
        this.forceHideClBadge = true
        this.needShowClBadge = false
      }
    },
    updateNeedShowClBadge() {
      if (this.forceHideClBadge) {
        this.needShowClBadge = false
        return
      }
      this.needShowClBadge = this.localStorage.getItem(LAST_SHOW_CL_VIA_BADGED_TAB_KEY) ? false : true
    },
    visitClEventsPage() {
      Cookies.set(VISITED_CL_EVENT_PAGE_COOKIE_KEY, true)
      this.isVisitedClEventsPage = true
    },

    setupFooterTabABTest() {
      const { isAPattern, isBPattern } = useABTestV2(FOOTER_TAB_AB_TEST_CONFIG)

      this.isFooterTabHidden = isBPattern

      // ABテストが有効な場合、GAイベント送信
      if (isAPattern || isBPattern) {
        if (import.meta.client) {
          // 既に送信済みの場合は送信しない
          if (Cookies.get(FOOTER_TAB_AB_TEST_GA_SENT_KEY)) {
            return
          }
          // 送信対象のGAイベントを取得
          GTM.sendEventToGa({
            ...AB_TEST_FOOTER_TAB_GROUP_ALLOCATION,
            label: isAPattern ? 'group_a' : 'group_b'
          })

          // 送信済みフラグをCookieに保存（テスト期間中有効）
          Cookies.set(FOOTER_TAB_AB_TEST_GA_SENT_KEY, 'true')
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.footerTab {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  height: 60px;
  z-index: 999;
  &.iphoneXSeries {
    height: 70px;
  }
  &-inner {
    @include flex;
    margin: auto;
    height: 100%;
    box-shadow: 0 -1px 6px 0 $gray-003;
    border-radius: 15px 15px 0 0;
    &-tab {
      position: relative;
      width: 50%;
      height: 100%;
      padding: 1rem 0;
      text-align: center;
      cursor: pointer;
      &:first-child {
        border-radius: 15px 0 0 0;
      }
      &:last-child {
        border-radius: 0 15px 0 0;
      }
      &.badge {
        &::before {
          content: 'N';
          position: absolute;
          height: 14px;
          min-width: 14px;
          padding: 2.8px 3px 3.6px 3.5px;
          font-size: 1rem;
          color: $white;
          line-height: 1;
          border-radius: 8px;
          background-color: $pink-thin;
          top: 5px;
          left: calc(50% + 5px);
        }
      }
    }
  }
}
</style>
